import { AxiosError } from 'axios';

import { CHANGE_PASSWORD_API_URL } from '@/constants/apis';
import { configuration } from '@/constants/config';
import { apiManager } from '@/helpers/api.manager';
import { ApiResponse } from '@/types/response.type';

export type ChangePasswordApiPayload = {
  userId: string;
  oldPassword: string;
  newPassword: string;
};

export type ChangePasswordApiResponse = {
  success: boolean;
  message: string;
};

const changePassword = async (
  payload: ChangePasswordApiPayload
): Promise<ApiResponse<ChangePasswordApiResponse>> => {
  try {
    const response = await apiManager.post(CHANGE_PASSWORD_API_URL, payload, {
      baseURL: configuration.CLERK_API_URL,
      headers: { 'Content-Type': 'application/json' },
    });

    if (response.status !== 200) {
      const error = response as unknown as AxiosError;
      return Promise.reject(error.response?.data);
    }

    return Promise.resolve(response.data);
  } catch (e) {
    return Promise.reject(e);
  }
};

export default changePassword;
